import { Link } from "@/i18n/LangRouting";
import { Play, Pause } from "lucide-react";
import { usePlayer } from "@/visitor/PlayerContext";
import { useI18n } from "@/i18n/I18nContext";
import { fmtTime } from "@/lib/api";

export default function MiniPlayer() {
  const { track, playing, time, duration, toggle, seek, hasAudio } = usePlayer();
  const { t } = useI18n();
  if (!track) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-40 border-t border-[var(--line)] bg-[#161616]/95 backdrop-blur-md" data-testid="mini-player">
      <div className="max-w-6xl mx-auto px-4 pt-3 pb-1">
        <input type="range" className="seek seek-lg" min={0} max={duration || 0} step={0.1} value={Math.min(time, duration || 0)} onChange={(e) => seek(Number(e.target.value))} disabled={!hasAudio} aria-label="Seek" data-testid="mini-player-seek" />
      </div>
      <div className="flex items-center gap-3 px-4 pb-3 pt-1 max-w-6xl mx-auto">
        <Link to={`/e/${track.slug}/a/${track.artwork.slug}`} className="flex-1 min-w-0" data-testid="mini-player-link">
          <p className="font-display uppercase truncate">{track.artwork.title}</p>
          <p className="text-xs text-[var(--muted)]">{hasAudio ? `${fmtTime(time)} / ${fmtTime(duration)}` : t("text_only")} · {track.lang.toUpperCase()}</p>
        </Link>
        <button type="button" onClick={toggle} disabled={!hasAudio} aria-label={playing ? "Pause" : "Play"} data-testid="mini-player-toggle" className="play-btn !w-12 !h-12">
          {playing ? <Pause size={20} fill="currentColor" /> : <Play size={20} fill="currentColor" className="ml-0.5" />}
        </button>
      </div>
    </div>
  );
}
